<template>
  <el-dialog :title="id ? '编辑导游' : '添加导游'" :visible.sync="dialogFormVisible" width="600px">
    <el-form
      ref="dataForm"
      :rules="rules"
      :model="temp"
      label-position="left"
      label-width="100px"
      style="margin: 0 30px"
    >
      <template>
        <el-form-item label="导游姓名" prop="name">
          <el-input v-model="temp.name" placeholder="请输入导游姓名" />
        </el-form-item>
        <el-form-item label="导游手机号" prop="mobile">
          <el-input
            type="mobile"
            v-model="temp.mobile"
            maxlength="11"
            placeholder="请输入导游手机号"
          />
        </el-form-item>
        <el-form-item label="身份证" prop="card_no">
          <el-input v-model="temp.card_no" maxlength="18" />
        </el-form-item>
        <el-form-item label="导游证" prop="cert_img">
          <img-upload v-model="temp.cert_img" class-name="banner-upload" tip-size="379px 260px" />
        </el-form-item>
        <el-form-item label="城市" prop="city">
          <CitySelect customStyle="width: 100%" v-model="temp.city" :show-all="false" />
        </el-form-item>
        <el-form-item label="服务项目" prop="projects">
          <el-select
            v-model="temp.projects"
            filterable
            placeholder="请选择"
            style="width: 100%"
            multiple
          >
            <el-option
              v-for="item in project_options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="OpenId" prop="openid">
          <el-input v-model="temp.openid" placeholder="请输入OpenId" />
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取消</el-button>
      <el-button type="primary" @click="saveData">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getDetail, add, edit } from '@/api/guides'
import { getList as getProjectList } from '@/api/projects'
import ImgUpload from '@/components/ImgUpload'
import CitySelect from '@/components/CitySelect'
const rule = [{ required: true, message: '必填项不能为空' }]
export default {
  name: 'GuidesEdit',
  components: { ImgUpload, CitySelect },
  data() {
    return {
      dialogFormVisible: false,
      id: '',
      temp: {
        name: '',
        mobile: '',
        card_no: '',
        cert_img: '',
        city: '',
        projects: [],
        openid: ''
      },
      rules: {
        name: rule,
        mobile: rule,
        card_no: rule,
        cert_img: rule,
        city: [{ required: true, message: '请选择城市', trigger: 'change' }],
        projects: rule,
        openid: rule
      },

      project_options: []
    }
  },
  created() {
    getProjectList({ size: 1000 }).then((res) => {
      this.project_options = res.data.results
    })
  },
  methods: {
    // 添加
    handleCreate() {
      this.id = ''
      this.temp = {
        name: '',
        mobile: '',
        card_no: '',
        cert_img: '',
        city: '',
        projects: [],
        openid: ''
      }
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    // 编辑
    handleEdit(id) {
      getDetail(id).then((res) => {
        this.id = id
        Object.assign(this.temp, {
          ...res.data,
          projects: res.data.projects.map((item) => item.id)
        })
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs.dataForm.clearValidate()
        })
      })
    },
    // 保存
    saveData() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          if (!this.temp.cert_img) {
            return this.$message.error('请上传图片')
          }
          if (!/^(1[3-9]\d{9})$/.test(this.temp.mobile)) {
            return this.$message.error('请输入正确的手机号!')
          }
          if (!/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(this.temp.card_no)) {
            return this.$message.error('请输入正确的身份证号!')
          }
          const d = JSON.parse(JSON.stringify(this.temp))
          const p = this.id ? edit(this.id, d) : add(d)
          p.then(() => {
            this.$parent.fetchData()
            this.dialogFormVisible = false
            this.$parent.$notify({
              title: '成功',
              message: this.id ? '修改成功' : '添加成功',
              type: 'success'
            })
          })
        }
      })
    }
  }
}
</script>
